module.exports = __webpack_public_path__ + "img/Yi_Xing-1.575ad755.png";